export default "/images/qr_app.png?e81e9de58edfdff016ede2b182c8a69c";